import ModalTemplate, {modalPageDecorator} from "./ModalTemplate";

export default modalPageDecorator({
  render (h) {
    return (
      <ModalTemplate>
        <div class="m-2 lg:my-12">
          <div class="bg-white container md:max-w-xl mx-auto rounded shadow-lg relative z-50">
            <div class="pb-6 p-3 lg:px-10">
              <div onClick={this.dismiss} class="cursor-pointer z-50 absolute right-0 top-0 m-3 lg:m-4">
                <i class="mdi mdi-close text-3xl lg:text-4xl leading-none text-shadow"></i>
              </div>
              <h3 class="text-base lg:text-xl font-bold lg:mt-5 mb-8 lg:mb-4">
                Reset Password
              </h3>
              <p class="text-sm mb-5">
                We have e-mailed your password reset link!
              </p>
              <button onClick={this.dismiss}
                class="px-5 p-2 lg:py-3 rounded-full font-serif bg-yellow-500 focus:outline-none focus:shadow-outline text-base"
                type="button">
                Ok
                <i class="mdi mdi-arrow-right ml-1"></i>
              </button>
            </div>
          </div>
        </div>
      </ModalTemplate>
    )
  }
});
